import Queue from 'toxilibs/queue.js'


// one template literal per folder: esbuild bundles every file it can match, and only those
const stepImporters = {
    levels:       (name) => import(`../levels/${name}.js`),
    levels_maths: (name) => import(`../levels_maths/${name}.js`)
}


async function importStep (stepPath) {
    const [folder, ...rest] = stepPath.split('/')
    const module = await stepImporters[folder](rest.join('/'))
    return module.default
}


function getStepDependencies (params) {

    let stepsWithDependencies = []

    const loadedDependencies    = {}
    const acquiredDependencies  = {}



    function addStepsWithDependencies (steps, callback) {
        const queue = new Queue({
            onFinished: callback
        })
        queue.add(steps)

        queue.handleInSerie(addStepWithDependencies)

    }



    function addStepWithDependencies (step, callback) {
        if (loadedDependencies[step.name] || acquiredDependencies[step.name]) {
            callback()
            return
        }
        loadedDependencies[step.name] = true

        loadSteps(step.dependencies, function () {
            stepsWithDependencies.push(step)
            callback()
        })

    }






    function loadSteps (stepPaths, callback) {
        if (!stepPaths || stepPaths.length === 0) {
            callback()
            return
        }
        Promise.all(stepPaths.map(importStep)).then(function (loadedSteps) {
            if (params.noDependencies) {
                stepsWithDependencies = loadedSteps
                callback()
            } else {
                addStepsWithDependencies(loadedSteps, callback)
            }
        })
    }


    function prepareForOutput () {
        for (let i = 0; i < stepsWithDependencies.length; i++) {
            stepsWithDependencies[i].id = stepsWithDependencies[i].name // TODO: is this usefull ? id is already set in Level constructor
        }

        params.callback(stepsWithDependencies)
    }



    if (params.acquiredStepPaths) {
        getStepDependencies({
            wantedStepPaths: params.acquiredStepPaths,
            callback: function (acquiredStepsWithDependencies) {
                for (let i = 0; i < acquiredStepsWithDependencies.length; i++) {
                    acquiredDependencies[acquiredStepsWithDependencies[i].name] = true
                }
                loadSteps(params.wantedStepPaths, prepareForOutput)
            }
        })
    } else {
        loadSteps(params.wantedStepPaths, prepareForOutput)
    }




}





export default getStepDependencies

